import React from 'react'

import { PieChart, Pie, ResponsiveContainer, Tooltip } from 'recharts';

import { IChartData, IChartProps } from '../../../interfaces/charts';

const PieChartComponent = (props: IChartProps) => {
    const { xLabel, data, width, height, color } = props;

    const generateColors = (count: number): string[] => {
        const colors: string[] = [];
        const saturation = 85; // Increased for more vibrant colors
        const lightness = 55;  // Adjusted for richer tones
        for (let i = 0; i < count; i++) {
            const hue = Math.floor((360 / count) * i);
            colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
        }
        return colors;
    };

    const labels = data.map((item: IChartData) => item.name);

    const colorPalette = generateColors(data.length);
    const enrichedData = data.map((item, idx) => ({
        ...item,
        fill: color === 'auto' ? colorPalette[idx] : item.fill
    }));

    return (
        <div className='immersion_admin__chart_container'>
            <div className='immersion_admin__chart_container__label__X'>
                <h5 className='immersion_admin__chart_container__label__X__text'>{xLabel}</h5>
            </div>

            <div className='immersion_admin__chart_container__pie_chart'>
                <ResponsiveContainer minWidth={width} height={height}>
                    <PieChart>
                        <Tooltip />
                        <Pie
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            outerRadius={150}
                            labelLine={false}
                            data={enrichedData}
                            dataKey="value"
                            activeIndex={-1}
                            isAnimationActive={false}
                        />
                    </PieChart>
                </ResponsiveContainer>
                <div className='immersion_admin__chart_container__pie_chart__legend'>
                    {labels.map((label: string, idx: number) => (
                        <div className='immersion_admin__chart_container__pie_chart__legend__item' key={idx}>
                            <div className='immersion_admin__chart_container__pie_chart__legend__item__color' style={{ backgroundColor: enrichedData[idx].fill }} />
                            <p className='immersion_admin__chart_container__pie_chart__legend__item__text'>{label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default PieChartComponent